import { render, staticRenderFns } from "./media-detail.vue?vue&type=template&id=37f942dc"
import script from "./media-detail.vue?vue&type=script&lang=js"
export * from "./media-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports